import { OcrMethods } from "../tenant-configurations/tenant-configurations-types";
import { Company } from "../companies/companies-types";

export interface Mailbox {
    id: string;
    name: string;
    address: string;
    disabled: boolean;
    company: Company | null;
    ocrMethod: OcrMethods | null;
    creator?: string | null;
    creationDate?: Date | null;
}

export interface MailboxDefault extends Mailbox {
    exists: boolean;
}

export enum MailboxCreationType {
    Generic,
    Company,
    All,
}
